import { render } from "./CorrectReasonView.vue?vue&type=template&id=2e6cdf98&scoped=true&ts=true"
import script from "./CorrectReasonView.vue?vue&type=script&lang=ts"
export * from "./CorrectReasonView.vue?vue&type=script&lang=ts"

import "./CorrectReasonView.vue?vue&type=style&index=0&id=2e6cdf98&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6cdf98"]])

export default __exports__